module.exports = __webpack_public_path__ + "asset/image/lock-0a55.svg";